<template>
  <div class="home">
    <header-bar></header-bar>
    <section class="main">
      <div class="nav-left">
        <div class="nav-list">
          <div
            class="go-back-personal el-icon-arrow-left"
            @click="$router.push('/user/personal/' + userInfo.id)"
          >
            返回个人主页
          </div>
          <h3 class="on">资料修改</h3>
        </div>
      </div>
      <div class="mainconten-right user-info">
        <el-form ref="form" :rules="rules" :model="form" label-width="80px">
          <div class="form-top">
            <div class="form-title">账号基本信息</div>
            <el-form-item label="头像">
              <div class="avatar-uploader">
                <el-upload
                  class="avatar-main"
                  :action="baseUrl+'/upload/image'"
                  :data="uploadImgParam"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  :show-file-list="false"
                  accept=".png,.jpg,.jpeg"
                  >
                  <img
                    :src="form.icon||'../../../static/img/mr-usericon.png'"
                    class="avatar"
                  />
                  <i class="el-icon-camera-solid avatar-uploader-icon"></i>
                  <div class="upload-text">上传新头像</div>
                  <div class="zhc-box"></div>

                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="用户名" prop="userName">
              <el-input
                v-model="form.userName"
                placeholder="4～30个字符，支持中英文、数字"
              ></el-input>
            </el-form-item>
            <el-form-item label="个性签名">
              <el-input
                type="textarea"
                v-model="form.intro"
                maxlength="30"
                show-word-limit
                placeholder="介绍一下自己吧～"
                resize="none"
              ></el-input>
            </el-form-item>
            <el-form-item label="认证手机">
              <span>{{ form.phone }}</span>
              <el-button class="code-num" @click="dialogVisible = true"
                >重新认证</el-button
              >
            </el-form-item>
          </div>
          <div class="form-bottom">
            <div class="form-title">个人基本信息</div>
            <el-form-item label="性别">
              <el-radio-group v-model="form.sex">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="0">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="生日">
              <el-date-picker
                v-model="form.birthDate"
                format="yyyy-MM"
                value-format="yyyy-MM"
                type="month"
                placeholder="请选择"
                @change="changeDate"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="地址">
              <el-input
                v-model="form.address"
                placeholder="请输入详细地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="兴趣爱好" class="xqah">
              <span class="tips">（多选）</span>
              <el-checkbox-group v-model="type" @change="interestsCheck">
                <el-checkbox-button
                  v-for="(item, index) in interestsData"
                  :label="item"
                  :key="index"
                  :name="item"
                  >{{ item }}</el-checkbox-button
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit(form)">保存</el-button>
            </el-form-item>
          </div>
        </el-form>
        <el-dialog
          title="修改认证手机号"
          :visible.sync="dialogVisible"
          width="480px"
          :modal-append-to-body="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
        >
          <div class="login-success">
            <div class="login-input">
              <el-form ref="form" :rules="rules" :model="phoneForm">
                <div class="setting-phone-top">
                  使用手机{{ form.phone }}进行验证
                </div>
                <el-form-item prop="oldPhone">
                  <div class="phone-numbox">
                    <el-input
                      placeholder="请输入完整手机号"
                      v-model.trim="phoneForm.oldPhone"
                      clearable
                    >
                    </el-input>
                  </div>
                </el-form-item>
                <el-form-item prop="newPhone">
                  <div class="phone-numbox">
                    <el-input
                      type="number"
                      maxlength="11"
                      placeholder="请输入新手机号"
                      v-model.trim="phoneForm.newPhone"
                      clearable
                    >
                    </el-input>
                  </div>
                </el-form-item>
                <el-form-item>
                <div class="phone-num">
                  <el-input
                    placeholder="图形验证码"
                    maxlength="4"
                    v-model.trim="verifyCode"
                  >
                  </el-input>
                  <img @click="fetchCaptcha" style="cursor:pointer;height:46px;width: auto;" :src="captchaSrc" alt="Captcha" />
                </div>
              </el-form-item>
                <el-form-item prop="smsCode">
                  <div class="phone-num">
                    <el-input
                      placeholder="请填写手机验证码"
                      maxlength="6"
                      @keyup.enter.native="login('form')"
                      v-model.trim="phoneForm.smsCode"
                      clearable
                    >
                    </el-input>
                    <el-button
                      class="code-num"
                      :disabled="getsmsFlag"
                      @click="getsms"
                      >{{ btnsmsText }}</el-button
                    >
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <div class="login-next">
              <el-button type="danger" @click="updatePhone" round
                >确定</el-button
              >
              <el-button type="danger" @click="dialogVisible = false" round
                >取消</el-button
              >
            </div>
          </div>
        </el-dialog>
      </div>
    </section>
  </div>
</template>
<script>
import HeaderBar from "@/components/Header.vue";
export default {
  name: "Home",
  components: {
    HeaderBar,
  },
  data() {
    let checkPhone = function (rule, value, callback) {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        var reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      captchaSrc:'',
      verifyCode:'',
      uuid:'',
      userToken: localStorage.getItem("UserToken"),
      userInfo:
        localStorage.getItem("UserInfo") &&
        JSON.parse(localStorage.getItem("UserInfo")),
      dialogVisible: false,
      timer: 60,
      getsmsFlag: false,
      btnsmsText: "获取验证码",
      rules: {
        oldPhone: [
          {
            validator: checkPhone,
            trigger: "blur",
          },
        ],
        newPhone: [
          {
            validator: checkPhone,
            trigger: "blur",
          },
        ],
        smsCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
        userName: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },
      form: {
        icon: "",
        userName: "",
        intro: "",
        phone: "",
        sex: "",
        birthDate: "",
        address: "",
        interest: "", //兴趣爱好id
        interestStr: "", //兴趣爱好名称
      },
      phoneForm: {
        newPhone: "",
        oldPhone: "",
        smsCode: "",
      },
      type: [],
      interestsData: [],
      baseUrl:(window.location.host.indexOf('bbs.dahe.cn')>-1) ? "https://bbs-api.dahe.cn" : "https://bbs-api.dahe.cn",
      uploadImgParam:{
        water:1
      }
    };
  },
  methods: {
    fetchCaptcha() {
      this.$api
            .codeImage({})
            .then((res) => {
              this.captchaSrc = 'data:image/png;base64,' + res.data.data.img;
              this.uuid = res.data.data.uuid;
            })
    },
    getInterests() {
      this.$api.interests({}).then((res) => {
        this.interestsData = res.data.data;
      });
    },
    userMyDetail() {
      this.$api.userMyDetail({}).then((res) => {
        res.data.data.birthDate =
          res.data.data.birthYear + "-" + res.data.data.birthMonth;
        this.type = res.data.data.interestStr.split(",");
        this.form = res.data.data;
      });
    },
    interestsCheck() {
      let interestsId = [];
      for (var i = 0; i < this.type.length; i++) {
        for (var num in this.interestsData) {
          if (this.type[i] == this.interestsData[num]) {
            interestsId.push(num);
          }
        }
      }
      this.form.interest = interestsId.join(",");
      this.form.interestStr = this.type.join(",");
    },
    changeDate() {
      this.form.birthYear = this.form.birthDate.split("-")[0];
      this.form.birthMonth = this.form.birthDate.split("-")[1];
    },
    handleAvatarSuccess(res, file) {
      this.form.icon = URL.createObjectURL(file.raw);
    },
    updatePhone() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.userUpdatePhone(this.phoneForm).then((res) => {
            this.$message.success(res.data.msg);
            this.dialogVisible = false;
            localStorage.setItem("phone", this.phoneForm.newPhone);
          });
        }
      });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.userUpdate(this.form).then((res) => {
            this.$message.success({
              message: res.data.msg,
              onClose: () => {
                this.$router.push("/user/personal/" + this.userInfo.id);
              },
            });
            localStorage.setItem("UserInfo", JSON.stringify(this.form));
          });
        }
      });
    },
    // 获取验证码
    getsms() {
      if (this.phoneForm.newPhone.length !== 11) {
        this.$message({
          message: "请输入正确的手机号！",
          type: "error",
        });
        return false;
      }
      if (!this.verifyCode) {
        this.$message({
          message: "请输入图形验证码！",
          type: "error",
        });
        return false;
      }
      this.getsmsFlag = true;
      this.$api
        .sms({
          phone: this.phoneForm.newPhone,
          uuid:this.uuid,
          verifyCode:this.verifyCode,
          type: 3,
        })
        .then((res) => {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.djs = setInterval(() => {
            if (this.timer == 0) {
              this.timer = 60;
              this.btnsmsText = "重新发送";
              this.getsmsFlag = false;
              clearInterval(this.djs);
            } else {
              this.timer--;
              this.btnsmsText = this.timer + "s重新发送";
              this.getsmsFlag = true;
            }
          }, 1000);
        })
        .catch(() => {
          this.getsmsFlag = false;
        });
    },
    //上传图片
     handleAvatarSuccess(res, file) {
      this.form.icon = res.data;
      this.updateIcon(res.data);
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    //修改头像
    updateIcon(icon) {
      this.$api
        .userUpdateIcon({
          icon: icon,
        })
        .then((res) => {
          this.form.icon = icon;
          localStorage.setItem("UserInfo", JSON.stringify(this.form));
          this.$message({
            message: res.data.msg,
            type: "success",
          });
        });
    },
  },
  created() {
    this.userMyDetail();
    this.getInterests();
    this.fetchCaptcha()
  },
};
</script>
<style scoped lang="scss">
.main {
  width: 1000px;
  margin: 10px auto;
  margin-top: 70px;
  display: flex;
  justify-content: space-between;
  .nav-left {
    width: 250px;
    height: 903px;
    padding: 10px;
    background: #fff;
    .nav-list {
      h3 {
        padding-left: 18px;
        height: 48px;
        font-size: 20px;
        color: #121212;
        font-weight: 600;
        line-height: 48px;
        cursor: pointer;
        margin-top: 15px;
        &.on {
          color: #317DFF;
          background: #f5f5f5;
        }
      }
      .go-back-personal {
        width: 148px;
        height: 40px;
        line-height: 40px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #e5e5e5;
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        cursor: pointer;
        padding-left: 15px;
      }
    }
    .nav-ul {
      li {
        height: 48px;
        line-height: 48px;
        font-size: 18px;
        padding-left: 30px;
        cursor: pointer;
        i {
          margin-right: 10px;
          font-size: 20px;
        }
        &.on {
          color: #317DFF;
          background: #f5f5f5;
        }
      }
    }
  }
  /deep/ .mainconten-right {
    width: 740px;
    background: #fff;
    .form-top {
      width: 100%;
      padding: 24px;
      border-bottom: 2px solid #efefef;
      padding-bottom: 0;
    }
    .form-bottom {
      width: 100%;
      padding: 24px;
    }
    .el-form-item {
      .el-form-item__label {
        font-size: 16px;
        color: #121212;
      }
      .el-input {
        width: 420px;
        height: 42px;
      }
      .el-textarea {
        width: 420px;
        height: 70px;
        .el-textarea__inner {
          height: 70px;
        }
        .el-input__count {
          line-height: normal;
        }
      }

      .el-radio__inner {
        width: 16px;
        height: 16px;
      }
      .el-radio__input.is-checked .el-radio__inner {
        background: #317DFF;
        color: #317DFF;
        border-color: #317DFF;
      }
      .el-radio__inner:hover {
        border-color: #317DFF;
      }
      .el-radio__label {
        font-size: 16px;
      }
      .el-radio__input.is-checked + .el-radio__label {
        color: #121212;
      }
      .el-date-editor {
        width: 120px;
        height: 42px;
      }
      .el-checkbox-button__inner {
        padding: 8px 13px;
        margin-right: 10px;
        background: #f7f7f7;
        border-radius: 3px;
        border: 1px solid #e5e5e5;
        color: #121212;
        box-shadow: none;
      }
      .el-checkbox-button.is-checked .el-checkbox-button__inner {
        background: #fff;
        border-color: #317DFF;
        color: #317DFF;
      }
      .el-checkbox-button__inner:hover {
        color: #121212;
      }

      .el-button {
        width: 128px;
        height: 40px;
        background: #317DFF;
        border-radius: 4px;
        font-size: 15px;
        font-weight: 400;
        color: #ffffff;
        border-color: #317DFF;
      }
      .code-num {
        width: 100px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        color: #317DFF;
        text-align: center;
        border: none;
        padding: 0;
        background: transparent;
      }
      &.xqah{
        position: relative;
      }
      .tips{
        position: absolute;
        left: -66px;
        top: 25px;
        font-size: 14px;
        color: #666;
      }
    }

    .form-title {
      width: 100%;
      height: 26px;
      line-height: 26px;
      border-left: 4px solid #317DFF;
      padding-left: 10px;
      font-size: 18px;
      font-weight: 600;
      color: #121212;
      margin-bottom: 24px;
    }
    .avatar-uploader {
      position: relative;
      width: 110px;
      height: 110px;
      display: block;
      border-radius: 50%;
      background: rgba(63, 63, 63, 0.44);
      border: none;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      img.avatar {
        width: 110px;
        height: 110px;
        border-radius: 50%;
        position: absolute;
        left: 0;
      }
      .avatar-uploader-icon {
        position: absolute;
        font-size: 28px;
        color: #fff;
        width: 110px;
        height: 110px;
        line-height: 110px;
        text-align: center;
        left: 0;
        z-index: 1;
        top: 0;
      }
      .upload-text {
        position: absolute;
        bottom: 10px;
        font-size: 12px;
        color: #fff;
        left: 50%;
        margin-left: -24px;
        z-index: 1;
      }
      .zhc-box {
        width: 110px;
        height: 110px;
        border-radius: 50%;
        position: absolute;
        left: 0;
        background: rgba(63, 63, 63, 0.44);
      }
    }
  }
  /deep/ .el-dialog {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 4px;
    .el-dialog__header {
      border-bottom: 1px solid #efefef;
      .el-dialog__title {
        font-size: 17px;
        font-weight: 600;
        color: #121212;
      }
    }
    .el-dialog__body {
      padding: 0;
      .login-success {
        width: 100%;
        padding: 10px 70px 50px;
        display: flex;
        align-items: center;
        flex-direction: column;
        img {
          width: 72px;
          height: 72px;
        }
        .login-title {
          font-size: 18px;
          font-weight: 600;
          color: #121212;
          margin-top: 15px;
        }
        .login-sum {
          font-size: 16px;
          font-weight: 400;
          color: #666666;
          text-align: center;
          line-height: 22px;
          margin-top: 20px;
        }
        .login-input {
          width: 100%;
          .setting-phone-top {
            font-size: 18px;
            font-weight: 400;
            color: #121212;
            margin-bottom: 22px;
          }
          .phone-num {
            width: 100%;
            display: flex;
            height: 48px;
            border-radius: 3px;
            background: #ffffff;
            // margin-top: 16px;
            border: 1px solid #e5e5e5;
            .el-input {
              margin-top: 0;
              width: 240px;
            }
            .code-num {
              width: 100px;
              height: 48px;
              line-height: 48px;
              font-size: 14px;
              color: #317DFF;
              text-align: center;
              border: none;
              padding: 0;
              background: transparent;
            }
          }
          .phone-numbox {
            width: 100%;
            display: flex;
            height: 48px;
            border-radius: 3px;
            background: #ffffff;
            border: 1px solid #e5e5e5;
            .el-input {
              margin-top: 0;
            }
          }
          .el-input {
            height: 46px;
            margin-top: 16px;
            .el-input__inner {
              height: 46px;
              border-radius: 3px;
              background: #ffffff;
              border: none;
            }
            .el-input__suffix {
              height: 100%;
            }
          }
        }
        .login-next {
          width: 100%;
          margin-top: 30px;
          display: flex;
          justify-content: space-around;
          .el-button {
            width: 128px;
            height: 40px;
            background: #317DFF;
            border-radius: 4px;
            font-size: 15px;
            color: #ffffff;
          }
          .el-button:nth-child(2) {
            background: #dddddd;
            border-radius: 4px;
            border: 1px solid #dddddd;
            color: #2f2f2f;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/personalSetting.vue